import { createSlot } from "lib/@components/slot/create-slot"

// Injection point above the regime/facilities landing grid. The recipient-facing share-link introduction
// plugs in here so the facilities page can keep the order: introduction, facilities, requested fields.
export const RegimeLandingTopPanel = createSlot("RegimeLandingTopPanel")

// Injection point on the regime/facilities landing grid, rendered below the facility tiles. The
// recipient-facing share-link landing panel (requested fields + comments) plugs in here so the landing
// page itself stays free of share-link concerns.
export const RegimeLandingPanel = createSlot("RegimeLandingPanel")
